<template>
  <div id="uploader"
       v-loading="loading">
    <!-- <p class="pq">一次性最多能传20张图片</p> -->
    <div style="padding: 1.333vw 4vw;">
      <div class="imgList">
        <div class="imgItem"
             v-for="(item,index) in base64SrcList"
             :key="index"
             :style="'background: url('+item+') no-repeat;'">
          <van-icon class="delete"
                    @click="beforeDelete('isWx',index)"
                    name="cross" />
        </div>
      </div>
      <!--   v-if="haveAppid&&fileList.length <= 20" -->
      <!-- <div class="addImgButton"

           @click="chooseImg">
        <van-icon name="plus" />
      </div> -->
      <van-uploader v-model="fileList"
                    multiple
                    :max-count="100"
                    :after-read="afterRead"
                    :before-delete="beforeDelete">
        <div class="add"
             data-v-6595121d>
          <img width="40vw"
               src="@/assets/uploader/add.png"
               alt="">
        </div>
      </van-uploader>
      <van-button @click="openClick"
                  round
                  class="btn"
                  type="info"
                  :color="isSimple?'#F65D27':'#185ED3'">下一步 </van-button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { uploadPic } from "@/api/file";
import { createStore } from "@/store";
const store = createStore();
import { Dialog, Toast } from 'vant';
import { getWeixinTicketAsync } from '@/plugins/wxConfig'
Vue.use(Toast);
export default {
  data () {
    return {
      loading: false,
      fileList: this.$store.state.user.fileList || [],
      haveAppid: false,
      base64SrcList: [],
      // base64SrcList: ['http://cdp-local-web.test.routeryuncs.com/uploads/picture/2021-04-28/0f54b97b5b971d115bef5798d47c811d.jpg@h160.jpg',
      //   'http://cdp-local-web.test.routeryuncs.com/uploads/picture/2021-04-28/0f54b97b5b971d115bef5798d47c811d.jpg@h160.jpg',
      //   'http://cdp-local-web.test.routeryuncs.com/uploads/picture/2020-11-30/c2f6020a4049f603b9e12be3792b0595.jpg@h160.jpg',
      //   'http://cdp-local-web.test.routeryuncs.com/uploads/picture/2021-04-28/0f54b97b5b971d115bef5798d47c811d.jpg@h160.jpg'],
    };
  },


  methods: {
    ...mapActions(["setIsUpload"]),
    ...mapActions(["setFileList"]),
    ...mapActions(["setToken"]),
    ...mapActions(["setCreateUid"]),
    openClick () {
      if (this.fileList.length === 0) {
        Toast('请选择图片！');
      } else {
        localStorage.setItem('isUpload', false)
        this.setIsUpload(false)
        this.$router.push({
          path: '/save',
          query: {
            token: store.state.user.token,
            date: store.state.user.expirationTime,
            createUid: store.state.user.createUid,
            powers: JSON.stringify(store.state.user.powers)
          }
        })
      }
    },

    afterRead (file) {
      // for (let i = 0; i < this.fileList.length; i++) {
      //   let _this = this
      //   this.fileList[i].name = this.fileList[i].file.name
      //   var reader = new FileReader();
      //   reader.readAsDataURL(this.fileList[i].file);
      //   reader.onload = function (e) { 
      //     _this.fileList[i].baseFile = this.result
      //   }
      // }
      this.loading = true
      setTimeout(() => {
        this.setFileList(this.fileList)
        // sessionStorage.setItem('fileList',JSON.stringify(this.fileList))
        // this.setUserSettingAsync(this.$route.query.createUid,'fileList',JSON.stringify(this.fileList))
      }, 100);
      setTimeout(() => {
        this.loading = false
      }, 2000);
      // let a = this.$md5(fd)
      // file.status = 'uploading';
      // file.message = '上传中...';
      // let fd = new FormData();
      // fd.append("file", file.file);
      // this.uploadPicAsync(fd,file)
    },
    beforeDelete (file, detail) {
      if (file == 'isWx') {
        this.base64SrcList.splice(detail, 1)
        this.fileList.splice(detail, 1)
      } else {
        this.fileList.splice(detail.index, 1)
      }
      // for (let i = 0; i < this.fileList.length; i++) {
      //   let _this = this
      //   this.fileList[i].name = this.fileList[i].file.name
      //   var reader = new FileReader();
      //   reader.readAsDataURL(this.fileList[i].file);
      //   reader.onload = function (e) { 
      //     _this.fileList[i].baseFile = this.result
      //   }
      // }
      setTimeout(() => {
        this.setFileList(this.fileList)
        // sessionStorage.setItem('fileList',JSON.stringify(this.fileList))
        // this.setUserSettingAsync(this.$route.query.createUid,'fileList',JSON.stringify(this.fileList))
      }, 100);

      // console.log(this.fileList)
    },
    async uploadPicAsync (val, file) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        file.status = "done";
        // console.log(data);
      }
    },
    chooseImg () {
      let wx = window.wx
      let that = this
      // console.log(wx);
      // alert('chooseImg')
      wx.chooseImage({
        count: this.fileList.length + 9 > 20 ? 20 - this.fileList.length : 9, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        defaultCameraMode: "batch", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。从3.0.26版本开始支持front和batch_front两种值，其中front表示默认为前置摄像头单拍模式，batch_front表示默认为前置摄像头连拍模式。（注：用户进入拍照界面仍然可自由切换两种模式）
        isSaveToAlbum: 1, //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
        success: function (res) {
          // alert('res.localIds' + res.localIds.length)
          // that.localIds.push(res.localIds[0])
          // alert('that.localIds' + that.localIds)
          for (let i = 0; i < res.localIds.length; i++) {
            // alert('res.localIds[i]  ', res.localIds[i])
            wx.getLocalImgData({
              localId: res.localIds[i], // 图片的localID
              success: function (res1) {
                // that.wxPicFileList = res1.localData; // localData是图片的base64数据，可以用img标签显示
                const localData = res1.localData;
                let imageBase64 = '';
                if (localData.indexOf('data:image') == 0) {
                  //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                  imageBase64 = localData;
                } else {
                  //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                  //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                  imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                }
                // alert('imageBase64', imageBase64.substring(0, 30))
                that.base64SrcList.push(imageBase64)
                // that.dataURLtoBlob(imageBase64)
                that.dataURLtoFile(imageBase64, 'jpg')
              }
            });
          }
          // andriod中localId可以作为img标签的src属性显示图片；
          // iOS应当使用 getLocalImgData 获取图片base64数据，从而用于img标签的显示（在img标签内使用 wx.chooseImage 的 localid 显示可能会不成功）
        }
      });
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      // alert('mime' + mime)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let file = new File([u8arr], filename, { type: mime })
      // this.wxPicFileList.push(file)
      // alert('fileList.size' + file.size)
      // alert('fileList.name' + file.name)
      // alert('this.wxPicFileList' + JSON.stringify(this.wxPicFileList))
      // alert('fileList' + JSON.stringify(this.fileList))
      // return new File([u8arr], filename, { type: mime });
      this.fileList.push({ "file": file, "content": dataurl, "status": "", "message": "" })
      this.fileList.isWX = this.base64SrcList
      setTimeout(() => {
        this.setFileList(this.fileList)
      }, 100);
    },
  },
  created () {
    this.setToken(this.$route.query.token)
    console.log(this.$route.query.token);
    this.setCreateUid(this.$route.query.createUid)
    var u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (isAndroid) {
      var ua = window.navigator.userAgent.toLowerCase();
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        // this.isWeChat = true;
        getWeixinTicketAsync(window.location.href.split('#')[0])
        if (localStorage.getItem('noAppId')) {
          this.haveAppid = false
        } else {
          this.haveAppid = true
        }
      } else {
        // this.isWeChat = false;
      }
    }
  },
  mounted () {

  }
};
</script>

<style lang="scss" scoped>
@import "./mobileAtlas.scss";
</style>